module.exports = __webpack_public_path__ + "media/images/billing/pessoa-triste-dbd34f1ed72147ec13e6d191dbf9a68d.svg";